define('constants/analyticsShowTypeConstants',[], function() {
    return {
        calls : "calls",
        chats : "chats",
        minutes : "minutes"
    };
});
